module.exports = __webpack_public_path__ + "img/ic_arrow_with_tail.8ecccda5.svg";